module.exports = __webpack_public_path__ + "static/img/cover.d4b0692a.png";